"use client";

import * as React from "react";
import { apiPlugin, storyblokInit } from "@storyblok/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { DraftModeProvider } from "./_components/DraftModeProvider";
import { componentMapping } from "@/config/sb-component-mapping";
import { I18nProviderClient } from "@/locales/client";
import { getQueryClient } from "@/lib/clients/query-client";
import { setLanguageCode } from "@/lib/clients/graphql-request-client";
export interface ProvidersProps {
  children?: React.ReactNode;
  draftMode?: boolean;
  locale: string;
}
storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN,
  use: [apiPlugin],
  components: componentMapping
});
export function Providers({
  children,
  draftMode,
  locale
}: ProvidersProps) {
  const queryClient = getQueryClient();

  // // Set the language code for all subsequent requests on client
  setLanguageCode(locale);
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="Providers" data-sentry-source-file="providers.tsx">
      <I18nProviderClient locale={locale} data-sentry-element="I18nProviderClient" data-sentry-source-file="providers.tsx">
        <DraftModeProvider draftMode={draftMode} data-sentry-element="DraftModeProvider" data-sentry-source-file="providers.tsx">{children}</DraftModeProvider>
        <ReactQueryDevtools data-sentry-element="ReactQueryDevtools" data-sentry-source-file="providers.tsx" />
      </I18nProviderClient>
    </QueryClientProvider>;
}